module.exports = __webpack_public_path__ + "static/media/ic-prev-stop-arrow-disabled.d109f6f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-prev-stop-arrow-disabled.svg
// module id = 420
// module chunks = 0